/*// !equalHeight
-------------------------------------------------- */

// !equal height for divs in a row e.g. footer for equal border heights
var equalHeight = function(container) {

	var currentTallest = 0,
			currentRowStart = 0,
			rowDivs = [],
			$el,
			currentDiv = 0,
			topPosition = 0;
		
	$(container).each(function() {
		
		$el = $(this);
		$($el).height('auto');
		topPosition = $el.position().top;
		
		if (currentRowStart !== topPosition) {
			for (currentDiv = 0 ; currentDiv < rowDivs.length ; currentDiv++) {
				rowDivs[currentDiv].height(currentTallest);
			}
			rowDivs.length = 0; // empty the array
			currentRowStart = topPosition;
			currentTallest = $el.height();
			rowDivs.push($el);
		} else {
			rowDivs.push($el);
			currentTallest = (currentTallest < $el.height()) ? ($el.height()) : (currentTallest);
		}
		for (currentDiv = 0 ; currentDiv < rowDivs.length ; currentDiv++) {
			rowDivs[currentDiv].height(currentTallest);
		}
		
	});

};
// call equalHeight function on .load and .resize
$(window).load(function() { equalHeight('.equalheight'); }).resize(function() { equalHeight('.equalheight'); });


// ... document.ready()
$(document).ready(function(){
	
	
/*// !equalHeight - extend for hidden content e.g. panels
-------------------------------------------------- */

$('.panel-title > a.collapsed').click(function(){
	var panel = $(this).closest('.panel'),
			equalheight =	panel.find('.equalheight');
	panel.find('.collapse').show();
	if ( equalheight.length ) {
		equalHeight(equalheight);
	}
	panel.find('.collapse').removeAttr('style');
});


/*// !Carousel
-------------------------------------------------- */

// stage carousel
var owl = $('.owl-carousel');

owl.slick({
	arrows: false,
	infinite: true,
	fade: true,
	speed: 500,
	autoplay: false,
	cssEase: 'linear',
	dots: true,
	focusOnChange: true,
	accessibility: true
});


/*// !Panels - open/collapse all
-------------------------------------------------- */

// open all collapsed panels on click
$('.expandpanels, .expandallpanels').on('click', function(){

	var btn = $(this);
	
	function collapse(focus) {
		if ( btn.hasClass('true') ) {
			focus.find('.panel-collapse').collapse('show');		
		}
		if ( btn.hasClass('false') ) {
			focus.find('.panel-collapse').collapse('hide');		
		}		
	}

	if ( btn.hasClass('expandpanels') ) {
		collapse( btn.closest('.panel-group' ));		
	}
	if ( btn.hasClass('expandallpanels') ) {
		collapse( btn.closest('.primary') );		
	}
	
	btn.toggleClass('true false');
	btn.parent().find('span').toggleClass('hidden');
	
});


/*// !Nav
-------------------------------------------------- */

// sticky navbar
var sticky = new Waypoint.Sticky({
  element: $('#mainnav'),
  stuckClass: 'navbar-fixed-top'
});
/* IE9 and below only */
/*@cc_on
  @if (@_jscript)
  	$('#mainnav').removeClass('sb-slide');
  	$('#mainnav').addClass('sb-site-container');
		sticky.destroy();
  @end
@*/

// offcanvas via slidebars
var mySlidebars = new $.slidebars({
  disableOver: 1024, // integer or false
  hideControlClasses: true, // true or false
  scrollLock: false // true or false	
});
$('.sb-toggle').on('click', function() {
  mySlidebars.slidebars.toggle('left');
});

$('.body').on('click', function() {
	mySlidebars.slidebars.close();
});

// submenu for bootstrap navbar

$('.navbar-nav li:not(.dropdown-submenu):not(.dropdown)').click(function(e){ e.stopPropagation(); });
$('.dropdown-submenu > a').click(function(){ return false; });
$('.dropdown-submenu > a').submenupicker();


/*// !Tab WAI Extras
-------------------------------------------------- */

$('.navbar-collapse.visible-md.visible-lg > ul > li.dropdown > .dropdown-menu > li:last-child > a').focusout(function(){
	$(this).parents('.dropdown-menu').dropdown('toggle');
});

$('.sb-toggle').on('click', function() {
	$('.sb-slidebar.sb-active .sb-close').focus();
});


$('.sb-slidebar .navbar-nav > li:last-child > a').focusout(function(){
	mySlidebars.slidebars.close();
	$('.sb-toggle .navbar-toggle').focus();
});

/*// !Popover
-------------------------------------------------- */

// prevent Default
$('[data-toggle="popover"]').click(function(e){
	e.preventDefault();
});
// initialize all popeovers
$('body').popover({
	template: '<div class="popover" role="tooltip"><button type=button" class="iconfont-close btn btn-link popover-close" data-dismiss="popover" aria-hidden="true"></button><h3 class="popover-title"></h3><div class="popover-content"></div></div>',
	placement: 'top',
	selector: '[data-toggle=popover]',
	trigger: "click"
}).on("show.bs.popover", function(e){
	// hide all other popovers
	$("[data-toggle=popover]").not(e.target).popover("destroy");
	$("[data-dismiss=popover]").closest('[data-toggle=popover]').popover("destroy");
	$(".popover").remove();                    
});
// dismiss popover on click close btn
$(document).on('click', '[data-dismiss=popover]', function(e){
	e.preventDefault();
	$("[data-dismiss=popover]").closest('.popover').prev().popover("destroy");
	$(".popover").remove();
});


/*// !ScrollToTop
-------------------------------------------------- */

//Check to see if the window is top if not then display button
$(window).scroll(function(){
	if ($(this).scrollTop() > 500) {
		$('.scrollToTop').addClass('in');
	} else {
		$('.scrollToTop').removeClass('in');
	}
});	
//Click event to scroll to top
$('.scrollToTop').click(function(){
	$('html, body').animate({scrollTop : 0},800);
	return false;
});


/*// !Search
-------------------------------------------------- */

// toggle extended search
$('.toggleSearch').click(function(){
	$(this).closest('.searchwrapper').find('.search-extended').toggleClass('visuallyhidden');
	$('span',this).toggleClass('visuallyhidden');
});


/*// !Modal - Gallery
-------------------------------------------------- */

//This function disables buttons when needed
function disableButtons(counter_max, counter_current, _this){
	_this.find('.controls .btn').show();
	if(counter_max === counter_current){
		_this.find('.next').hide();
	} else if (counter_current === 1){
		_this.find('.prev').hide();
	}
}
/* @param setIDs: sets IDs when DOM is loaded. If using a PHP counter, set to false. */
function loadGallery(setIDs, setClickAttr, target){
	var _this = $(target),
			current_image,
	    selector,
	    counter = 0;
	_this.find('.controls .btn').click(function(){
		if( $(this).hasClass('prev') ){
			current_image--;
		} else {
			current_image++;
		}
		selector = $('[data-image-id="' + current_image + '"]');
		updateGallery(selector);
	});
	
	function updateGallery(selector) {
	  var $sel = selector;
	  current_image = $sel.data('image-id');
	 	// $('#image-gallery-caption').text($sel.data('caption')); // caption for image - not in use
	 	// $('#image-gallery-title').text($sel.data('title')); // gallery title - not in use
	  _this.find('.image').attr('src', $sel.data('image'));
	  
	  disableButtons(counter, $sel.data('image-id'), _this);
	}
	
	if(setIDs === true){
		$('[data-image-id]').each(function(){
	  	counter++;
	    $(this).attr('data-image-id',counter);
	  });
	}
	$(setClickAttr).on('click',function(){
		updateGallery($(this));
	});
}

// init gallery if modal gallery exists
if ( $('#modalGallery').length ) {
	loadGallery(true, 'a.thumbnail', '#modalGallery');	
}

function searchPrimo() {
	document.getElementById("primoQuery").value = "any,contains," + document.getElementById("primoQueryTemp").value.replace(/[,]/g, " ");
	document.forms["searchForm"].submit();
}

function searchPrimoHome() {
	document.getElementById("primoQueryHome").value = "any,contains," + document.getElementById("primoQueryTempHome").value.replace(/[,]/g, " ");
	document.forms["searchFormHome"].submit();
}

window.searchPrimo = searchPrimo;
window.searchPrimoHome = searchPrimoHome;

}); // end of document.ready()